interface SourceChannelSelectorProps {
  value: string | null;
  onChange: (channel: string | null) => void;
}

const SOURCE_CHANNEL_OPTIONS = [
  { value: "", label: "Të gjitha" },
  { value: "Web", label: "Web" },
  { value: "MobileApp", label: "Mobile App" },
  { value: "Admin", label: "Admin" }
];

export const SourceChannelSelector: React.FC<SourceChannelSelectorProps> = ({ value, onChange }) => (
  <select
    value={value || ""}
    onChange={(e) => onChange(e.target.value || null)}
    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm
      focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary
      bg-white text-sm"
  >
    {SOURCE_CHANNEL_OPTIONS.map((option) => (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    ))}
  </select>
);
